<template>
  <div class="pl-10 pr-1 sm:px-8 py-3 flex flex-col w-full h-full">
    <h1 class="mb-3 text-sm text-white font-bold">Management Pengguna</h1>
    <div
      v-if="selectedUser === null"
      class="Scroll pr-1 sm:pr-5 w-full h-full overflow-hidden">
      <div class="flex flex-row w-full mb-3 gap-3">
        <form
          @submit.prevent="searchUser()"
          class="relative flex flex-grow">
          <input
            v-model="username"
            class="px-3 py-3 flex-grow h-8 form-input rounded-md text-xs"
            type="text"
            placeholder="cari username ...">
          <button
            @click="searchUser()"
            class="absolute px-3 py-3 flex items-center right-0 top-0 h-8"
            type="button">
            <i class="material-icons text-lg text-gray-500">search</i>
          </button>
        </form>
        <button
          @click="addUser()"
          class="flex flex-row justify-center items-center p-2 bg-green-500 rounded-md">
          <i class="material-icons text-xs text-white mr-1">add</i>
          <span class="text-xs text-white">Tambah Pengguna</span>
        </button>
      </div>
      <div class="flex flex-col sm:flex-row sm:flex-wrap mb-3">
        <div
          v-for="(user, index) in users.data"
          :key="index"
          class="flex flex-col p-3 sm:w-2/4 lg:w-1/3 bg-gray-400 rounded border border-gray-500">
          <span class="text-sm text-white">{{ user.username }}</span>
          <span class="text-xs text-gray-100">{{ user.fullname }} <small>({{ user.role_name }})</small></span>
          <div class="flex gap-1 justify-end items-center">
            <button
              @click="editUser(user)"
              class="flex justify-center items-center w-5 h-5 bg-gray-100 rounded-full text-green-500"
              type="button"
              title="Edit Pengguna">
              <i class="material-icons text-sm">edit</i>
            </button>
            <button
              @click="deleteUser(user)"
              class="flex justify-center items-center w-5 h-5 bg-gray-100 rounded-full text-red-500"
              type="button"
              title="Hapus Pengguna">
              <i class="material-icons text-sm">delete</i>
            </button>
          </div>
        </div>
      </div>
      <Pagination
        class="justify-end items-end"
        :offset="users.offset"
        :limit="users.limit"
        :total="users.total"
        :handler="changePage" />
    </div>
    <div
      v-if="selectedUser"
      class="flex flex-col mb-3">
      <button
        @click="selectedUser = null"
        class="flex flex-row justify-center items-center px-2 py-1 w-44 bg-gray-400 rounded-md">
        <i class="material-icons text-lg text-white mr-1">chevron_left</i>
        <span class="text-xs text-white">Kembali Ke Pengguna</span>
      </button>
    </div>
    <div
      v-if="selectedUser"
      class="w-full h-full overflow-hidden">
      <FormUser :userId="selectedUser ? selectedUser.id : null" />
    </div>
    <PopupConfirm ref="PopupUser" />
    <PopupMessage :message="message" :confirm="{ success: confirmSuccess }" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FormUser from './FormUser.vue'
import Pagination from './Pagination.vue'
import PopupConfirm from './PopupConfirm.vue'
import PopupMessage from './PopupMessage.vue'

export default {
  name: 'TableUsers',
  data: () => ({
    username: null,
    selectedUser: null,
    deletedUser: null
  }),
  computed: {
    ...mapGetters([
      'message',
      'users'
    ])
  },
  components: {
    FormUser,
    Pagination,
    PopupConfirm,
    PopupMessage
  },
  methods: {
    ...mapActions([
      'loadUsers',
      'toDeleteUser'
    ]),
    addUser: function () {
      this.selectedUser = true
    },
    editUser: function (user) {
      this.selectedUser = user
    },
    deleteUser: function (user) {
      this.deletedUser = user

      this.$refs.PopupUser.show(
        `Apakah anda yakin ingin menghapus grup pengguna "${user.username}"?`,
        { handler: this.confirmDelete }
      )
    },
    confirmDelete: async function () {
      await this.toDeleteUser(this.deletedUser.id)
    },
    confirmSuccess: async function () {
      if (this.selectedUser) {
        this.selectedUser = null
      }

      await this.loadUsers()
    },
    changePage: async function (page) {
      await this.loadUsers({
        offset: page.offset,
        limit: page.limit
      })
    },
    searchUser: async function () {
      await this.loadUsers({
        username: this.username,
        fullname: this.username
      })
    }
  },
  mounted: async function () {
    await this.loadUsers()
  }
}
</script>
